module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0055.jpg?v=44277aa6";